import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import HeaderNav from "src/components/Nav/HeaderNav";
import { useNavbarLivePreview } from "src/hooks/useNavbarLivePreview";

/**
 * Payload Live Preview iframe target for `navbar-items` (same UX as Promotions).
 * Shows the full Playground header with the live-edited item merged into the tree.
 * Always available for CMS editors — independent of REACT_APP_PAYLOAD_SOURCES.
 */
const NavbarPreview = () => {
  const { i18n } = useTranslation();
  const locale = i18n.language === "fr" ? "fr" : "en";
  const { links, isResolved } = useNavbarLivePreview(locale);

  return (
    <PreviewPage>
      <HeaderNav linksOverride={links} isResolvedOverride={isResolved} />
    </PreviewPage>
  );
};

const PreviewPage = styled.div`
  min-height: 100vh;
  background: var(--black);
  color: var(--white);
  padding-top: 120px;
`;

export default NavbarPreview;
